export default "__VITE_ASSET__DACDJQR8__"